<template>
  <div class="comment">
    <el-dialog style="font-size: 12px" title="留言" :visible.sync="dialogVisible" width="80%">
      <div>
        <el-form ref="form" :model="formData" :rules="rules">
          <el-form-item prop="content">
            <el-input type="textarea" v-model="formData.content" rows="4" placeholder="请输入留言内容"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input class="mt-md" v-model="formData.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="handelSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      formData: {
        phone: "",
        content: "",
      },
      rules: {
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        content: [{ required: true, message: "请输入留言内容", trigger: "blur" }],
      },
    };
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    open() {
      this.dialogVisible = true;
    },
    handelSure() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios.post("/leave-message", this.form).then((res) => {
            console.log(res);
            if (res.status == 0) {
              this.dialogVisible = false;
              this.resetForm();
              this.$message.success("提交成功");
              this.$emit("success");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.comment {
  ::v-deep .el-dialog__title {
    font-size: 16px;
  }
  ::v-deep .el-button {
    padding: 6px 8px;
  }
}
</style>
